import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import SortedHeader from "../../components/Tables/SortedHeader";
import { UserService } from "../../services/UserService";
import IconThreeDots from "../../layout/others/three-dots.svg";
import Pagination from "../../components/Pagination";
import { useHistory } from "react-router";

export default function UserPermissions(props) {
  const [users, setUser] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [searchObject, setSearchObject] = useState({});
  const [totalPages, setTotalPages] = useState(0);
  const [isListLoading, setIsListLoading] = useState(false);
  const { t } = useTranslation();
  const pageSize = 20;
  let history = useHistory();
  const [headers, setHeaders] = useState([
    { label: "Name", field: "UserName", sorted: true },
    { label: "Email", field: "Email" },
    { label: "Role", field: "userRoles" },
    { label: "" }
  ]);

  useEffect(() => {
    setIsListLoading(true);
    UserService.getAllUsers(pageSize, pageNumber, searchObject).then((data) => {
      setUser(data.users);
      setTotalPages(Math.ceil(data.totalUsers / pageSize));
      setIsListLoading(false);
    });
  }, [searchObject, pageNumber]);

  function onChange({ target }) {
    setSearchObject({ ...searchObject, [target.name]: target.value });
  }

  function onEditUser(event, userId) {
    event.stopPropagation();
    history.push(`/permissions/edit/${userId}`);
  }

  return (
    <>
      <div>
        <div className="d-flex row m-2">
          <div className="col-auto form-group">
            <input
              className="form-control"
              onChange={onChange}
              value={searchObject.nameOrEmail}
              placeholder={t("Name or Email")}
              name="nameOrEmail"
              style={{ width: "240px" }}
            />
          </div>
          <div className="col-auto form-group">
            <select
              className="form-control"
              onChange={onChange}
              value={searchObject.roleId || ""}
              name="roleId"
              style={{ width: "240px" }}
              required
            >
              <option value="" selected>
                {t("Role")}
              </option>
              {props.roles.map((role) => (
                <option key={role.id} value={role.id}>
                  {" "}
                  {t(role.description)}
                </option>
              ))}
            </select>
          </div>
        </div>
        <hr />
      </div>
      <div className="table-wrapper">
        {isListLoading ? (
          <>
            <table className="table-responsive">
              <thead>
                <SortedHeader
                  searchObject={searchObject}
                  setSearchObject={setSearchObject}
                  headers={headers}
                  setHeaders={setHeaders}
                />
              </thead>
            </table>
          </>
        ) : (
          <table>
            <thead>
              <SortedHeader
                searchObject={searchObject}
                setSearchObject={setSearchObject}
                headers={headers}
                setHeaders={setHeaders}
              />
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id}>
                  <td className="text-truncate">{user.userName}</td>
                  <td className="text-truncate">{user.email}</td>
                  <td className="text-truncate">
                    {t(user.roles[0]?.description)}
                  </td>
                  <td className="text-end">
                    <div className="dropdown">
                      <button
                        className="action-button"
                        type="button"
                        id="export"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <img
                          src={IconThreeDots}
                          alt="threedots"
                          title={t("Options")}
                        />
                      </button>
                      <ul className="dropdown-menu adjust-dropdown" aria-labelledby="more">
                        <li>
                          <a
                            href="#!"
                            className="dropdown-item"
                            onClick={(event) => {
                              onEditUser(event, user.id);
                            }}
                            title={t("Edit")}
                            data-bs-toggle="tooltip"
                          >
                            {t("Edit")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {users.length === 0 && (
          <div className="loader-wrapper">{t("No results were found.")}</div>
        )}
      </div>
      <div className="row">
        <div className="offSset">
          <Pagination
            totalPages={totalPages}
            setPageNumber={setPageNumber}
            pageNumber={pageNumber}
          />
        </div>
      </div>
    </>
  );
}
